<template>
  <div
    class="field"
    :class=" timeUse ? 'time' : ''"
    ref="main"
  >
    <input
      type="text"

      ref="field"
      :disabled="disabled"

      :maxlength="lenMax"
      :placeholder="$t( engType ? 'phDDMMYYYYe' : 'phDDMMYYYY'  ) + ( timeUse ? ' ' + $t( 'phHHMM' ) + ( secondsUse ? $t( 'phSS' ) : '' ) : '' )"

      :value="value_"

      v-ok="enter"

      @input="fieldInput( $event.target.value )"
      @beforeinput="mask"
      @blur="blur"
    />
    <Icon
      symbol="calendar"
      size="1em"
      class="button"
      @click.native="show = !show"
      :style="{ pointerEvents: disabled ? 'none' : 'unset' }"
    />

    <Tooltip
      :show="!!err"

      orientation="bottom"
      type="error"
      class="errorTip"
      @close="err=null"
    >
      <span v-html="err"></span>
    </Tooltip>

     <transition
      name="selector"
    >
      <Calendar
        v-if="show"
        class="calendar"

        :timeUse="timeUse"
        :secondsUse="secondsUse"
        :moFirst="moFirst"

        :value="valueRus"

        @input="setByCal( $event )"
      />
    </transition>
  </div>
</template>

<script>
import Icon from "./Icon";
import Calendar from "./Calendar";
import Tooltip from "./Tooltip";
import dates from "@/dates";

export default {
	name: "FieldCalendar",

	components: {
		Icon,
    Calendar,
    Tooltip
	},

  i18n: {
    messages: {
      ru: {
        phDDMMYYYY: "дд.мм.гггг",
        phDDMMYYYYe: "гггг-мм-дд",
        phHHMM: " чч:мм",
        phSS: ":cc",
        invalidDate: "неверный формат даты, используйте"
      },

      en: {
        phDDMMYYYY: "dd.mm.yyyy",
        phDDMMYYYYe: "yyyy-mm-dd",
        phHHMM: " hh:mm",
        phSS: ":ss",
        invalidDate: "invalid date format, use"
      },

      kz: {
        phDDMMYYYY: "кк.аа.жжжж",
        phDDMMYYYYe: "жжжж-аа-кк",
        phHHMM: "сс:мм",
        phSS: ":сс",
        invalidDate: "жарамсыз күн пішімі, пайдалану"
      }
    }
  },

  props: {
	  timeUse: {
	    type: Boolean,
      default: false
    },
	  secondsUse: {
	    type: Boolean,
      default: false
    },

    calendarHideOnSet: {
	    type: Boolean,
      default: true
    },

    calendarHideOnInput: {
	    type: Boolean,
      default: true
    },

    type: {
	    type: String,
      validate( v ) {
	      if (
	        v == "rus" ||
          v == "eng" ||
          v == "i18n"
        ) return true;

	      return false;
      },
      default: "i18n"
    },

    value: {
	    type: String
    },

    disabled: {
	    type: Boolean,
      default: false
    }
	},

	data() {
	  return {
	    show:   false,
      value_: "",
      err:    null,
    };
	},
/*
  beforeMount() {
	  this.value_ =  this.dateFromRusToType( this.value );
  },
*/
  mounted() {
	  const h = e => {
	    if ( e ) {
	      if ( e.type == "keydown" ) {
          if ( e.key === "Escape" ) {
            this.show = false;
            e.cancelBubble = true;
            return false;
          }
        }
	      else if ( e.type == "mousedown" ) {
	        const el = this.$refs.main;
	        if ( el && !el.contains( e.target ) ) {
            this.show = false;
            e.cancelBubble = true;
            return false;
          }
        }
      }
    };
    this.$options.seHandler = h;

	  document.addEventListener( "keydown", h );
	  document.addEventListener( "mousedown", h );
  },
  beforeUnmount() {
	  if ( this.$options.seHandler ) {
  	  document.removeEventListener( "keydown", this.$options.seHandler );
	    document.removeEventListener( "mousedown", this.$options.seHandler );
	    this.$options.seHandler = null;
    }
  },

	methods: {
	  enter() {
      this.update( true );
      if ( this.err === null ) this.$emit( "ok", this.valueRus );
    },
    blur() {
      this.update( true );
      if ( this.err === null )  this.$emit( "blur" )
    },
	  mask( e ) {
	    if ( e && e.data ) {
	      if ( this.maskReNoMatch.test( e.data ) ) {
          e.stopPropagation();
          e.preventDefault();
        }
      }
    },

    setByCal( e ) {
	    let dt = "";

	    if ( e ) dt = this.dateFormat( e, dates.types.STRUCT, this.type_ );

      if ( this.$refs.field ) this.$refs.field.focus();

      this.value_ = dt;

      this.emitInput( this.valueISO );
	    this.$emit( "calendar", this.valueRus );

	    if ( this.calendarHideOnSet ) this.show = false;
    },
/*
    setByCalOnChange( e ) {
	    if ( e && this.timeUse ) {
	      let t = {};

	      try {
  	      t = dates.parse( this.value, dates.types.RUS );
        }
        catch ( a ) {}

	      if ( t.day === undefined ) {
	        t.day   = e.day;
	        t.month = e.month;
	        t.year  = e.year;
        }

	      t.hours   = e.hours;
	      t.minutes = e.minutes;
	      t.seconds = e.seconds;

	      e = dates.format( e, dates.types.STRUCT, dates.types.RUS, true, true );
        if ( e ) this.value = e;
      }
    }
*/

    emitInput( v ) {
      //if ( this.$refs.field ) this.$refs.field.value = v;
      this.$emit( "input", v );
    },

    dateFormat( v, typeFrom, typeTo ) {
      if ( v ) {
        try {
          if ( typeFrom !== typeTo ) v = dates.format( v, typeFrom, typeTo, this.timeUse, true );
        }
        catch ( e ) {
          v = "";
        }

        if ( this.timeUse && !this.secondsUse ) return v.replace( /^(\S+ \d{1,2}:\d{1,2}):\d{1,2}$/, "$1" );
      }
      else v = "";

      return v;
    },
    dateFromTypeToRus( v ) {
      return this.dateFormat( v, this.type_, dates.types.RUS4Y );
    },
    dateFromRusToType( v ) {
      return this.dateFormat( v, dates.types.RUS4Y, this.type_ );
    },
    dateFromTypeToISO( v ) {
      return this.dateFormat( v, this.type_, dates.types.ISO );
    },
    fieldInput( v ) {
      this.value_ = v;

//      this.update();
      if ( this.calendarHideOnInput ) this.show = false;
    },

    update( errorShow ) {
      if (
        !this.value_ ||
        ( this.validRe.test( this.value_ ) && dates.isValid( this.value_, this.type_, this.timeUse ) )
      ) {
        this.$emit( "error", null );

        this.value_ = this.dateFormat( this.value_ );
        this.emitInput( this.valueISO );

        return;
      }

      let e = this.$t( "invalidDate" ) + " «" + this.$t( this.engType ? "phDDMMYYYYe" : "phDDMMYYYY" );
      if ( this.timeUse ) {
        e += " " + this.$t( "phHHMM" );
        if ( this.secondsUse ) e += this.$t( "phSS" );
      }
      e += "»";

      if ( errorShow ) this.err = e; else this.err = null;
      this.$emit( "error", e );
    }
  },

  computed: {
    moFirst() {
      return this.engType === false;
    },
	  type_() {
	    if ( this.type == "i18n" ) return this.$i18n.locale === "en" ? "eng" : "rus4y";

	    return this.type;
    },
	  valueRus() {
	    return this.dateFromTypeToRus( this.value_ );
    },
	  valueISO() {
	    return this.dateFromTypeToISO( this.value_ );
    },
	  maskReNoMatch() {
	    let ss = "0-9";
	    ss += this.engType ? "\\-" : "\\.";
	    if ( this.timeUse ) ss += " :";

      return new RegExp( "[^" + ss + "]" );
    },
    validRe() {
	    let re = this.engType ? "\\d{4}-\\d{2}-\\d{2}" : "\\d{2}\\.\\d{2}\\.\\d{4}";
	    if ( this.timeUse ) {
	      re += " \\d{2}:\\d{2}";
	      if ( this.secondsUse ) re += ":\\d{2}";
      }

      return new RegExp( "^" + re + "$" );
    },
	  engType() {
	    return this.type_ == "eng";
    },
    lenMax() {
	    let l = 10;
	    //if ( this.engType ) l += 2; //if year is 2 number (l must be = 8)
	    if ( this.timeUse ) {
	      l += 6;
	      if ( this.secondsUse ) l+= 3;
      }

	    return l;
    },
    propCanChangeValue() {
	    return [ this.value, this.type, this.$i18n.locale ];
    }
  },
  watch: {
	  propCanChangeValue: {
	    immediate: true,
  	  handler() {
	      this.value_ = this.dateFromRusToType( this.value );
      }
    }
  }
};
</script>

<style scoped>
  .field {
    padding: 0.2em;
    position: relative;
    display: inline-block;
    box-shadow: inset 0 0 3px #000000;
    border-radius: 0.2em;
    font: inherit;
  }

  .field > input {
    display: block;
    border: none;
    background: transparent;
    font: inherit;
    box-sizing: border-box;
    padding-right: 1.5em;
    min-width: 5em;
    color: inherit;
  }

  .field > .button {
    position: absolute;
    right: 0.2em;
    top: 50%;
    transform: translate( 0, -50% );
    cursor: pointer;
  }

  .field > .button:active {
    transform: translate( 0, -50% ) translate( 1px, 1px );
  }

  .field > .calendar {
    font: inherit;
    font-size: 0.8em;
    z-index: 5001;
    position: absolute;
    bottom: 0;
    left: 0;
    transform: translate( 0, 100% );
  }

  .field > .errorTip {
    min-width: 12em;
  }

  .selector-enter-active,
  .selector-leave-active {
    opacity: 1;
    transition: opacity .2s linear;
  }
  .selector-enter,
  .selector-leave-to {
    opacity: 0;
  }
</style>